/**
 * Code-aware error resolver for the admin staff endpoints (ADR-0015 D5).
 * Every validation the API performs before writing has its own code, so
 * the operator reads the rule that fired instead of a generic 400/403.
 * Side-effect free — unit-tested in `staff-admin-error.test.ts`.
 */
import { errorCodeOf } from "@/shared/api/error-code";
import { accessErrorKeyForCode } from "@/shared/organizations/access-errors";

type Translate = (key: string, values?: Record<string, unknown>) => string;

const ERROR_KEY_BY_CODE: Readonly<Record<string, string>> = {
  STAFF_USER_NOT_FOUND: "users.staff.errors.staffUserNotFound",
  TEST_PARTITION_MISMATCH: "users.staff.errors.testPartitionMismatch",
  ENTITY_NOT_OWNED: "users.staff.errors.entityNotOwned",
  NO_ENTITIES: "users.staff.errors.noEntities",
};

export function resolveStaffAdminError(err: unknown, t: Translate): string {
  const code = errorCodeOf(err);
  // The staff-specific copy first; every other access-model code (a stale
  // membership, an ineligible user, a kind mismatch...) shares its copy.
  const key = code ? (ERROR_KEY_BY_CODE[code] ?? accessErrorKeyForCode(code)) : undefined;
  return t(key ?? "users.staff.errors.generic");
}
